<div class="ontario-small-12 ontario-medium-6 ontario-large-12 ontario-margin-bottom-24-! ">
  <app-horizontal-radio-button-list [label]="'ClassEnrolment.EnrolmentRequestType' | translate"  [radioButtonOptions]="enrolRequestOptions" currentLang="en" (valueChange)="setEnrolRequestOption($event)" [value]="option.RequestType">
  </app-horizontal-radio-button-list>
</div>
<div class="ontario-small-12 ontario-medium-6 ontario-large-12 ontario-margin-bottom-24-! ">
  @if (option.RequestType=='1') {
    <app-horizontal-radio-button-list [label]="'ClassEnrolment.EnrolmentRequestFor' | translate"  [radioButtonOptions]="enrolSingleOptions" currentLang="en" (valueChange)="setEnrolOption($event)" [value]="option.RequestFor"></app-horizontal-radio-button-list>
  }
  @if (option.RequestType=='2') {
    <app-horizontal-radio-button-list [label]="'ClassEnrolment.EnrolmentRequestFor' | translate"  [radioButtonOptions]="enrolMutipleOptions" currentLang="en" (valueChange)="setEnrolOption($event)" [value]="option.RequestFor"></app-horizontal-radio-button-list>
  }
</div>
@if (option.RequestType == '2') {
  <div class="ontario-row box">
    <div class="ontario-column ontario-small-12 ontario-medium-4 ontario-large-4 ">
      <app-numeric-input  [label]="getLabel()"  [(value)]="option.Seats" (valueChange)="CreateSeats($event)" [min]="2" [max]="25"></app-numeric-input>
    </div>
  </div>
}
